import axios from "axios";
import {handlePromise} from "./promiseUtils";
import {LocalStorageUtil, SessionStorageUtil} from "./localStorageUtil";
import {AUTHENTICATION_KEY, IMPERSONATION_KEY} from "../context/authContext";

// use this axios client to call REST APIs, which don't required authenticated user like login, reset password etc...
const loginApiClient = axios.create({
  baseURL: process.env.REACT_APP_REST_API_BASE_URL,
  auth: {
    username: process.env.REACT_APP_API_USERNAME,
    password: process.env.REACT_APP_API_PASSWORD
  }
});

const mfaApiClient = axios.create({
  baseURL: process.env.REACT_APP_REST_API_BASE_URL
});

const login = (username, password, termsAccepted = false) => {
  SessionStorageUtil.removeObj(IMPERSONATION_KEY);
  const params = new URLSearchParams();
  const url = `/v1/auth/login`;
  params.append("username", username);
  params.append("password", password);
  if (termsAccepted) {
    params.append("isTermsAndAgreementsAccepted", "true");
  }
  return handlePromise(
      loginApiClient.post(
          url,
          params,
          { withCredentials: true }
      )
  );
};

const refreshAccessToken = () => {
  const params = new URLSearchParams();
  params.append("refresh_token", LocalStorageUtil.getPropertyValue(AUTHENTICATION_KEY, "refresh_token"));
  return handlePromise(
    loginApiClient.post(
      `/v1/auth/refresh`,
      params,
      { withCredentials: true }
    )
  );
};

const forgotPassword = email => {
  const sanitizedEmail = encodeURIComponent(email);
  return handlePromise(loginApiClient.get(`/v1/user-password/forgot/${sanitizedEmail}`));
};

const resetPassword = (token, password) => {
  const params = new URLSearchParams();
  params.append("token", decodeURIComponent(token));
  params.append("password", password);
  return handlePromise(loginApiClient.post("/v1/user-password/reset", params));
};

const verifyOtp = payload => {
  const params = new URLSearchParams();
  params.append("mfa_code", payload?.otp || "");
  return handlePromise(
      mfaApiClient.post(
          "/v1/auth/mfa",
          params,
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${payload?.mfaToken}`
            }
          }
      )
  );
};

const resendOtp = payload => {
  const params = new URLSearchParams();
  params.append("source", encodeURIComponent(payload?.source || "EMAIL"));
  const endpoint = `/v1/auth/send-mfa-code`;

  return handlePromise(mfaApiClient.post(
      endpoint,
      params,
      {
          headers: {
                Authorization: `Bearer ${payload?.mfaToken}`
          }
      }
  ));
};

export {
  login,
  forgotPassword,
  resetPassword,
  refreshAccessToken,
  verifyOtp,
  resendOtp,
  loginApiClient as noTokenApiClient
};
